import { createAsyncThunk } from "@reduxjs/toolkit";
import { getIndirectExpenseLedgerApi } from "../../apiservice/reports";
import { getAccountBySeachApi } from "../../apiservice/setting";
import { currentDateEndTime, currentDateStartTime } from "../../lib/functions";

export const fetchIndirectExpenseLedger = createAsyncThunk(
  "indirectExpenseLedger/fetch",
  async ({ filters }, { rejectWithValue }) => {
    try {
      const payload = {
        accId: filters?.accId || null,
        dateFrom: filters?.fromDate || null,
        dateTo: filters?.toDate || null,
      };
      const res = await getIndirectExpenseLedgerApi(payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchIndirectExpenseAccountsBySearch = createAsyncThunk(
  "indirectExpenseLedger/fetchAccountsBySearch",
  async (search, { rejectWithValue }) => {
    try {
      const res = await getAccountBySeachApi({
        query: search.trim(),
        search: true,
        multiType: ["indirect_expense"],
      });
      return (res.data || []).map((c) => ({
        sale_id: c.acc_id,
        display_text: c.acc_name,
      }));
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
